import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import { GET_COMPAIGN_META_CONFIG, GET_COMPAIGN_META_CONFIG_SUCCESS, GET_COMPAIGN_META_CONFIG_ERROR } from '../../../actions.js';
import apiCall from '../../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* getCompaignMetaDataConfig({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/surge-metadata/config`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMPAIGN_META_CONFIG_SUCCESS,
        payload: response?.data,
      });
    } else {
      const message = response?.response?.data?.message || `Failed to load campaign configuration.`;
      cogoToast.error(message);
      yield put({
        type: GET_COMPAIGN_META_CONFIG_ERROR,
        payload: message,
      });
    }
  } catch (error) {
    cogoToast.error(`Failed to load campaign configuration.`);
    yield put({ type: GET_COMPAIGN_META_CONFIG_ERROR, payload: error });
  }
}

export function* watchgetCompaignMetaDataConfig() {
  yield takeEvery(GET_COMPAIGN_META_CONFIG, getCompaignMetaDataConfig);
}

function* getCompaignMetaDataConfigSaga() {
  yield all([fork(watchgetCompaignMetaDataConfig)]);
}

export default getCompaignMetaDataConfigSaga;
